import React from 'react'

import { useSurveyQueryData } from './useSurveyQueryData'

export const useSurveyQueryQuestions = () => {
  const survey = useSurveyQueryData()

  return React.useMemo(() => survey?.questions ?? [], [survey?.questions])
}
